import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ConfirmDialogData } from '../../../domain/data/confirm-dialog-data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './confirm.dialog.html',
    styleUrls: ['./confirm.dialog.scss'],
})
export class ConfirmDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    constructor(el: ElementRef, parentEvents: ParentEvents, renderer: Renderer2, @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {
        super(parentEvents, el, renderer);
    }
}
